import { render, staticRenderFns } from "./writeOffOpenCardDetailed.vue?vue&type=template&id=36ff7450&scoped=true"
import script from "./writeOffOpenCardDetailed.vue?vue&type=script&lang=js"
export * from "./writeOffOpenCardDetailed.vue?vue&type=script&lang=js"
import style0 from "./writeOffOpenCardDetailed.vue?vue&type=style&index=0&id=36ff7450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff7450",
  null
  
)

export default component.exports